import React from 'react'
import TimePicker from 'ui-shared/WrappedInputs/TimePicker'
import EventMainProductSelectionInput from 'ui-shared/FormComponents/EventMainProductSelectionInput'
import { SelectionDetailsProps } from 'ui-shared/FormComponents/MainProductSelectionInputContent'
import {
  filterByTailored,
  useClientAndOrganizationIdFromEvent,
} from 'ui-shared/FormComponents/TailoredEventSelectionInput'
import { EventProductService } from 'services/api/entities/events/types/internal/services'
import { APIProfessionalFigure } from 'services/api/entities/catalog/professional/types/api/response-models'
import { ProfessionalFigure } from 'services/api/entities/catalog/professional/types/internal/professional-models'
import { professionalFigureParse } from 'services/api/entities/catalog/professional'
import { ProfessionalSection } from 'services/api/entities/catalog/sections/professionalSections'

type Props = SelectionDetailsProps<ProfessionalSection, EventProductService> & {
  professionals: APIProfessionalFigure[]
}

const useTailoredProfessionalFilter = (
  p: APIProfessionalFigure[]
): ProfessionalFigure[] => {
  const filterProfessionalsFn = filterByTailored(
    useClientAndOrganizationIdFromEvent()
  )
  return p.map(professionalFigureParse).filter(filterProfessionalsFn)
}

const ProfessionalFigureArrayInput: React.FC<Props> = ({
  getSource,
  isObsolete,
  professionals,
  ...rest
}) => {
  const selectableProfessionals = useTailoredProfessionalFilter(professionals)

  return (
    <EventMainProductSelectionInput
      {...rest}
      source={getSource!('selections')}
      label="Professional Figures"
      choices={selectableProfessionals}
      disableInputs={isObsolete}
    >
      <ProfessionalFigureTimeRangePicker />
    </EventMainProductSelectionInput>
  )
}

export default ProfessionalFigureArrayInput

const ProfessionalFigureTimeRangePicker: React.FC<
  SelectionDetailsProps<APIProfessionalFigure, EventProductService>
> = ({ getSource, isObsolete, ...rest }) => (
  <>
    <TimePicker
      {...rest}
      disabled={isObsolete}
      source={getSource!('startTime')}
      label="form.fields.startTime"
    />
    <TimePicker
      {...rest}
      disabled={isObsolete}
      source={getSource!('endTime')}
      label="form.fields.endTime"
    />
  </>
)
